import { AnalyticsStore } from 'bernie-plugin-mobx';
import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import '../client/temp-common-imports';

// Utils
import analyticsUtil from '../util/analytics-util';

export class ErrorController implements Controller {
  public pageId = 'page.affhub.error';
  public path = '/error';
  public routeName = 'error';
  public exact = true;
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "error-page" */ '../views/error-page'));

  public fetch(options: FetchOptions) {
    const { stores, request } = options;
    const analyticsStore: AnalyticsStore = stores?.get<AnalyticsStore>('analytics');

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, request.context);

    return Promise.resolve({});
  }

  public fetchPageData() {
    return Promise.resolve({ title: "Something's not right" });
  }
}
